// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.directorio_list button,ul.directorio_list li{cursor:pointer!important}.panel .nav_filter .nav_wrapper{border:0}.firma_user_name{max-width:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}@media (max-width:799px){.pagination{margin-bottom:100px!important}.group_filtro{padding-top:60px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
